import { frontendURL } from '../../../../helper/URLHelper';
import { CAMPAIGN_PERMISSIONS } from 'dashboard/constants/permissions.js';
const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');
const MassOutboundWizard = () => import('./MassOutboundWizard.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: SettingsContent,
      props: {
        headerTitle: 'CAMPAIGN.ONGOING.HEADER',
        headerGutterClass: 'px-4',
      },
      children: [
        {
          path: '',
          redirect: 'mass_outbound',
        },
        {
          path: 'ongoing',
          name: 'ongoing_campaigns',
          meta: {
            permissions: ['administrator', CAMPAIGN_PERMISSIONS],
          },
          component: Index,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: SettingsContent,
      props: {
        headerTitle: 'CAMPAIGN.ONE_OFF.HEADER',
        headerGutterClass: 'px-4',
      },
      children: [
        {
          path: 'one_off',
          name: 'one_off',
          meta: {
            permissions: ['administrator', CAMPAIGN_PERMISSIONS],
          },
          component: Index,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: SettingsContent,
      props: route => ({
        headerTitle:
          route.name === 'mass_outbound_edit'
            ? 'CAMPAIGN.WIZARD.HEADER_EDIT'
            : 'CAMPAIGN.WIZARD.HEADER',
        icon: 'send',
        showBackButton: true,
        keepAlive: false,
        backUrl: {
          name: 'mass_outbound',
          params: route.params,
        },
      }),
      children: [
        {
          path: 'mass_outbound/new',
          name: 'mass_outbound_new',
          meta: {
            permissions: ['administrator', CAMPAIGN_PERMISSIONS],
          },
          component: MassOutboundWizard,
        },
        {
          path: 'mass_outbound/:id/edit',
          name: 'mass_outbound_edit',
          meta: {
            permissions: ['administrator', CAMPAIGN_PERMISSIONS],
          },
          component: MassOutboundWizard,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: SettingsContent,
      props: {
        headerTitle: 'CAMPAIGN.MASS_OUTBOUND.HEADER',
        headerGutterClass: 'px-4',
      },
      children: [
        {
          path: 'mass_outbound',
          name: 'mass_outbound',
          meta: {
            permissions: ['administrator', CAMPAIGN_PERMISSIONS],
          },
          component: Index,
        },
      ],
    },
  ],
};
